import { Component, Input, OnDestroy, OnInit,  ElementRef, ViewChild } from '@angular/core';
import { CategoryService } from "src/app/services/category.service"
import { environment } from 'src//environments/environment';

declare const pdfjsLib: any;
@Component({
  selector: 'portal-right-section',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.less']
})

export class DealerPortalRightSectionComponent implements OnInit, OnDestroy {
    @ViewChild('pdfViewer') pdfViewer!: ElementRef;
    categoryList: any = []
    current: number = 1
    size: number = 3
    total: number = 0
    showPdfPreview: boolean = false
    pdfUrl: string = ""
    platformList:any[]=[{
      icon:"tips.svg",
      url:"https://ap.boschaftermarket.com/au/en/",
      title:"Mobility Aftermarket official website",
      desc:"More information about MA could be found here"
    },
    {
      icon:"app.svg",
      url:"https://appcenter.bosch.com/applications",
      title:"Bosch App Center",
      desc:"Application store"
    }]
    carouselList: any[] = [];


    get hasMoreNews(): boolean {
      return this.categoryList.length < this.total
    }

    constructor(
      private categoryService: CategoryService,
    ) { }

    // Init
    ngOnInit(): void {
      this.getData()

    }

    // Destroy
    ngOnDestroy(): void {
    }

    // get modules data
    getData(): void {
      const params = {
        current: this.current,
        size: this.size,
        isAdmin:false
      }
      this.categoryService.getCategoryList(params).subscribe((res) => {
        const { rtnCode, rtnData, rtnMsg } = res
        if (rtnCode === 10000) {
          this.categoryList = [...this.categoryList, ...rtnData.records || []]
          this.total = rtnData.total
        }
      })
    }
    // view more
    getMoreNewsletter(): void {
      if(!this.hasMoreNews) return
      this.current += 1
      this.getData()
  }
  // restore Newsletter
    restoreNewsletter(): void {
      this.categoryList = []
      this.current = 1
      this.getData()
  }


    // view more
    openWindow(url: string): void {
      window.open(url, '_blank');
  }

   // route to relate platform
    linkPlatform(url: string): void {
      window.open(url, '_blank');
  }
    //  view pdf online
  viewPdf(item: any): void {
    const BASE_PATH: string = environment.userCenterAdminUrl;
    window.open(`${BASE_PATH}/file/preview/${item.introductionFile}`, '_blank')
  }

  loadPdf(pdfUrl: string): void {
    this.showPdfPreview = true

  }

}